﻿[
  {
    "version": "1.38.0",
    "date": "October 31st, 2026",
    "summary": "🎃 Redesigned the home page with customizable shortcuts, quick-start difficulty selection, saved-game resume actions, and lesson progress.",
    "features": [
      "Start a classic Sudoku puzzle directly from the home page at your selected difficulty. Your difficulty selection is remembered between visits, and a saved puzzle can be resumed directly from the home page.",
      "Customize the home page by adding and removing shortcuts, searching the shortcut library, and dragging shortcuts into your preferred order. Shortcuts include individual classic difficulties, lessons, statistics, and profile settings. Your layout is saved between visits and can be reset to the default.",
      "The Learn Sudoku shortcut shows how many lessons you have completed."
    ],
    "preview features": [
      "Add shortcuts for individual drill strategies and resume a saved drill directly from the home page. Turning off Feature Preview or Drill Mode hides these shortcuts and resume actions without deleting your saved drill or shortcut preferences."
    ],
    "bug fixes": [
      "The game timer and solve time statistics no longer display malformed times of an hour or longer, i.e. one hour displayed as 01:00:0 instead of 01:00:00."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.37.1",
    "date": "October 31st, 2026",
    "summary": "🎃 Fixed the Statistics page not immediately updating after statistics are deleted.",
    "bug fixes": [
      "The Statistics page now immediately resets after the user deletes their statistics, instead of showing stale values until the page is revisited."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.37.0",
    "date": "September 7th, 2026",
    "summary": "After completing a game, users can now start a new game or drill immediately with a single click, and the 'Total Hints Used' statistic can be expanded to show the breakdown of hints used per strategy.",
    "features": [
      "After finishing a classic Sudoku game, a 'New Game' button lets the user start a new game immediately.",
      "The 'Total Hints Used' statistic is now collapsed by default and can be expanded to show how many hints were used for each strategy. The expansion is hidden when no hints have been used."
    ],
    "preview features": [
      "After finishing a drill, a 'New Drill' button lets the user start a new drill of the same strategy immediately."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.36.0",
    "date": "September 7th, 2026",
    "summary": "Added ability to filter and search release notes",
    "features": ["Added ability to filter and search release notes."],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.35.1",
    "date": "August 20th, 2026",
    "summary": "Improved light mode theming for cards on the Home, Lesson, and Release Notes pages.",
    "bug fixes": [
      "Lesson, difficulty, and release note cards now use theme aware colors that display correctly in light mode."
    ],
    "preview features": [
      "Drill cards now use theme aware colors that display correctly in light mode."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.35.0",
    "date": "August 15th, 2026",
    "summary": "Redesigned the Sudoku game interface to fit more screen sizes, improved board controls and status information, and made hints easier to use.",
    "features": [
      "Redesigned Sudoku game interface to fit on mobile screen sizes. On short mobile screens, the navigation header is hidden while playing to provide more room for the game. Users will still be able to navigate away from the page with the pause button.",
      "The Sudoku board header row has been re-styled and now displays number of hints used, mistakes made, and the Sudokuru logo. The Pause button has been moved to the action row located below the Sudoku board.",
      "The action row has been re-styled. The pause button is now grouped with the other game actions on the action row.",
      "Reorganized the number controls into two rows instead of one row. This will make it easier to select a value since the buttons are now wider.",
      "The hint display now lets the user exit at any stage of the hint. The hint display formatting has also been restructured to fit better on smaller screens.",
      "Hint progress is now automatically saved, so resuming a paused game that had a hint active will return the user to the same stage of the hint.",
      "Made notes darker and easier to read on the Sudoku board."
    ],
    "bug fixes": [
      "If a user paused their game or drill on the last stage of a hint for a drill, resuming the drill would show the user the completed drill without any indication that the drill had already been completed. This is fixed by having the Sudoku board remember the exact hint position to return the user to."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.34.1",
    "date": "August 1st, 2026",
    "summary": "Fixed the background color on web so it always matches the user's selected theme.",
    "bug fixes": [
      "Fixed the background color on web so it always matches the user's selected theme."
    ],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.34.0",
    "date": "May 7th, 2026",
    "summary": "Users can now toggle the Sudokuru site theme by pressing t twice.",
    "features": [
      "Users can now toggle the Sudokuru site theme by pressing t twice. This hotkey is ignored when in a text input field to prevent interference with typing."
    ],
    "bug fixes": [
      "T and t hotkeys no longer toggle notes, since N and n hotkeys already do this."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.33.0",
    "date": "May 4th, 2026",
    "summary": "Layout enhancements to the Play page, Drill page, and Lessons page. These pages are restructured to fit on smaller screens such as on mobile devices.",
    "features": [
      "Play page simplified from 'Play a Sudoku game' to 'Play Sudoku'. This helps with mobile sizing. It is also more clear and direct.",
      "Learn page simplified from 'Learn new strategies' to 'Learn Sudoku'. This helps with mobile sizing. It is also more clear and direct.",
      "The Learn page now uses the same rendering algorithm as the Play page. This improves consistency across the site.",
      "The Lesson buttons status icons are updated to a simpler design."
    ],
    "preview features": [
      "Drill page simplified from 'Train with a strategy' to 'Drill Sudoku'. This helps with mobile sizing. It is also more clear and direct.",
      "The Drill page now uses the same rendering algorithm as the Play page. This improves consistency across the site.",
      "The Drill button icons are now the same as the Play button icons for displaying relative difficulty."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.32.1",
    "date": "March 12th, 2026",
    "summary": "Sudoku board hotkeys functionality now works even if the board is not selected.",
    "bug fixes": [
      "Sudoku board hotkeys now work even if the board is not selected. Previously, hotkeys would only work when the user has selected a cell on the board. Hotkeys would stop working when the user clicked away from the sudoku board."
    ],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.32.0",
    "date": "February 19th, 2026",
    "summary": "Added Drills to feature preview and updated hint logic to improve quality of hints given.",
    "preview features": [
      "Added Drill mode functionality back to the site. Drills were removed in version 1.16.0 to reduce complexity of the site while refactoring the codebase. Drills will now show incorrect movies immediately instead of requiring the user to hit a 'check solution' button. The erase button is replaced with a reset button, since reset will be more useful than erase in the context of drills."
    ],
    "bug fixes": [
      "Improved the strategy quality for obvious, hidden, and pointing sets when the strategy hint order is changed from the default. This removed false positives for these strategies."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.31.0",
    "date": "November 6th, 2025",
    "summary": "Revamped the app theming to improve upon the look of the application, added a new dark theme, and replaced the light/dark mode toggle with three theme selection buttons in the profile page.",
    "features": [
      "Added a new dark theme option in the profile page.",
      "Replaced light/dark mode toggle in the profile page with theme selection buttons."
    ],
    "bug fixes": [
      "Fixed a dead link to a contributors GitHub profile in the about us page."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.30.1",
    "date": "October 31st, 2025",
    "summary": "🎃 Fixed bug where starting a new game would not immediately save the game state.",
    "bug fixes": [
      "Starting a new game will now immediately save the game so it can be resumed later. Previously the game would save only after the player interacted with the Sudoku board."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.30.0",
    "date": "April 24th, 2025",
    "summary": "Added simplify notes setting as a preview feature to auto simplify notes after value has been correctly inserted.",
    "preview features": [
      "Added simplify notes setting to auto simplify notes after value has been correctly inserted."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.29.1",
    "date": "March 20th, 2025",
    "summary": "Fixed a rare issue where clicking on a cell would not register the selection.",
    "bug fixes": [
      "Fixed a rare issue where clicking on a cell would not register the cell selection. This would occur for selections of a cell with notes if the click lined up with a 1 second interval refresh loop. This was a regression that was introduced in version 🎃 1.26.0"
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.29.0",
    "date": "March 20th, 2025",
    "summary": "Added initialize notes setting as a preview feature to be able to start a game with the notes already filled in.",
    "preview features": [
      "Added initialize notes setting to be able to start a game with the notes already filled in."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.28.3",
    "date": "February 13th, 2025",
    "summary": "Updated popup styling, removed outdated question mark popups, and fixed bug where popups would appear out of view.",
    "features": [
      "Updated popup styling including sizing, borders, and buttons.",
      "Removed outdated popups accessible from question marks which were also removed."
    ],
    "bug fixes": [
      "Fixed a bug where the popup appeared in the center of the entire scroll view instead of the center of the visible screen area."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.28.2",
    "date": "January 26th, 2025",
    "summary": "When deleting statistics, learned lessons would temporarily display nothing on profile page instead of 'None'.",
    "bug fixes": [
      "After deleting statistics, learned lessons immediately display as 'None' on profile page."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.28.1",
    "date": "January 25th, 2025",
    "summary": "A selected cell with notes was incorrectly highlighted as green instead of blue when identical values setting was enabled.",
    "bug fixes": [
      "A selected cell with notes now is always highlighted as blue even when the identical values setting is enabled."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.28.0",
    "date": "January 19th, 2025",
    "summary": "Adding a progress indicator to the Sudoku board. By default, the user can see how many remaining cells of a particular value are left.",
    "features": [
      "User has new profile option - Progress Indicator. When enabled, the numpad will have a gradient showing the user how many remaining cells of a particular value are left."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.5",
    "date": "December 10th, 2024",
    "summary": "Text is now selectable on web and desktop",
    "features": [
      "All text excluding the sudoku board text is now selectable on the web and desktop versions of the app. This allows copy and paste functionality, as well as helps for those who prefer to select text as they read."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.4",
    "date": "December 1st, 2024",
    "summary": "Reverted change that made sudoku board text selectable, as well as other areas in the app.",
    "bug fixes": [
      "Reverted the change that made the sudoku board text selectable which made playing the game more difficult."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.3",
    "date": "November 21st, 2024",
    "summary": "Enhanced visual feedback by changing selected cell colors to improve visibility of identical values.",
    "features": [
      "Selected cells now turn green when they contain valid values and the 'highlight identical values' setting is enabled, making it easier to identify cells with matching values."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.2",
    "date": "November 3rd, 2024",
    "summary": "The website / app no longer crashes if the user's data becomes corrupted.",
    "bug fixes": [
      "If user's data becomes invalid or corrupted, it is deleted to prevent the app/site from crashing."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.1",
    "date": "November 2nd, 2024",
    "summary": "Fixed bug where Sudoku games were not being saved and could not be resumed after pausing.",
    "bug fixes": [
      "Fixed bug where Sudoku games were not being saved and could not be resumed after pausing."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.27.0",
    "date": "November 2nd, 2024",
    "summary": "Renaming Sudoku strategies to allow for better translations and align with Sudoku.com terminology.",
    "features": [
      "Renamed Sudoku strategies to Obvious Single, Obvious Pair, Obvious Triplet, and Obvious Quadruplet.",
      "Renamed Sudoku lessons to Obvious Single and Obvious Set."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.26.0",
    "date": "October 31st, 2024",
    "summary": "🎃 Adding hints back to sudoku board. Adding ability to change hint strategy order.",
    "features": [
      "User can now click a hint. There are 5 stages to the hint which show the user how to continue the sudoku puzzle.",
      "UI interface for changing the hint priority order is moved out of feature preview and is visible on profile page.",
      "User can now see the number of hints they used after completing a game, and the total hints they have used on the statistics page.",
      "User can now see the number of hints used for each strategy after completing a game, and the total number they have used on the statistics page.",
      "User can use hotkeys 'h' or 'H' for triggering a hint"
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.25.0",
    "date": "October 24th, 2024",
    "summary": "Added about us page and fixed difficulty selection button text overflow bug",
    "features": [
      "Added about us page containing our mission, history, team members, and links"
    ],
    "bug fixes": [
      "Fixed a bug where on some small mobile devices difficulty button text would overflow"
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.24.2",
    "date": "September 12th, 2024",
    "summary": "Fixing issue with loading profile data on mobile devices and adding preview feature to change hint strategy order",
    "bug fixes": [
      "Fixed a crash scenario on mobile when a user had partial profile data stored and loads profile page."
    ],
    "preview features": [
      "Added UI interface on profile page for changing the hint priority order for strategies.",
      "Includes up and down arrows for changing priority order, and a reset button for reseting to default order.",
      "Settings are stored on user's device, so the data is saved between sessions."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.24.1",
    "date": "August 24th, 2024",
    "summary": "Updated profile page so that items fit better on the page.",
    "features": [
      "Added a master switch for highlight settings to disable or enable all highlight settings."
    ],
    "bug fixes": [
      "Fixed issue where profile settings would not fit on some mobile device screens."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.24.0",
    "date": "August 22nd, 2024",
    "summary": "Added Feature Preview mode for the user to preview incomplete or upcoming features.",
    "features": [
      "Added a toggle switch in profile page for turning on and off Feature Preview mode.",
      "Added an indicator on the page header for if the user is in Feature Preview mode."
    ],
    "preview features": [
      "Moved drill functionality into Preview Feature mode as it is incomplete."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.23.0",
    "date": "August 11th, 2024",
    "summary": "New difficulty selection panel on Play page",
    "features": [
      "Replaced difficulty buttons with cards with images and descriptions when resized large enough",
      "Removed start game button in favor of clicking on the difficulty card to start a game"
    ],
    "bug fixes": [
      "Fixed bug where the difficulty selection panel would not display correctly on mobile devices"
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.22.0",
    "date": "August 11th, 2024",
    "summary": "Added Release notes page",
    "features": [
      "Added release notes page for the user to see history and new updates to the app/site."
    ],
    "bug fixes": [
      "The size of the navigatino drawer has been slightly increased to be able to fit all elements."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.21.2",
    "date": "August 1st, 2024",
    "summary": "Fixed image display bugs and navigation / routing issue",
    "bug fixes": [
      "Eliminated bug on web where logo would flash when navigating to a different page.",
      "Fixed bug where there is no way to navigate to Lesson page once user has entered lesson without closing app or refreshing page.",
      "Fixed bug where there is no way to navigate to Play page once user has entered a game without closing app or refreshing page."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.21.1",
    "date": "July 18th, 2024",
    "summary": "Fixed issue where some pages in app overlapped with phone icons on top of page (time, battery indicator, etc).",
    "bug fixes": [
      "App no longer overlaps with phone icons at the top of the page."
    ],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.21.0",
    "date": "July 13th, 2024",
    "summary": "This release adds the ability to select multiple cells at the same time for mass notes insertions.",
    "features": [
      "Users can now select multiple Sudoku cells using hotkeys.",
      "Shift select and control select (meta select on mac) are supported.",
      "Users can insert notes into all selected cells.",
      "Users can move the selection box using arrow keys or wasd keys."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.20.0",
    "date": "July 4th, 2024",
    "summary": "Added additional difficulties for play game and regenerated puzzle library.",
    "features": [
      "Added additional difficulties: protege, professional, pundit, master, grandmaster.",
      "Regenerated puzzle library with newly generated puzzles with updated difficulty thresholds."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.19.2",
    "date": "April 30th, 2024",
    "summary": "Sudoku board hotkeys now work when board is not selected.",
    "bug fixes": [
      "Sudoku board hotkeys now work when board is not selected. However, the board needs to have been selected at least once."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.19.1",
    "date": "April 18th, 2024",
    "summary": "Home navigation buttons no longer resize when hovered over. Instead they gain glowing borders.",
    "features": [
      "Home navigation buttons no longer resize when hovered over. Instead they gain glowing borders."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.19.0",
    "date": "April 11th, 2024",
    "summary": "Added arrow key navigation for selected cell and additional hotkeys.",
    "features": [
      "Arrow keys and wasd (or WASD) keys can be used to move the selected cell in a Sudoku game.",
      "'e' and 'E' are added to '0' as hotkeys for erasing a selected cell's contents.",
      "'u', 'U' are added as hotkeys for undoing the latest move.",
      "'p', 'P' are added as hotkeys for pausing the game.",
      "'t', 'T', 'n', 'N', are added as hotkeys for toggling note mode."
    ],
    "targets": ["web", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.18.0",
    "date": "April 7th, 2024",
    "summary": "Greatly increased the puzzle catalog and added difficulty modes.",
    "features": [
      "Created new difficulties: amateur, layman, novice, and trainee.",
      "Added ability to see the current difficulty level when playing a game.",
      "Greatly increased the number of available puzzles for users to play."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant", "Gregory711"]
  },
  {
    "version": "1.17.0",
    "date": "March 23rd, 2024",
    "summary": "Contact page is added to the site.",
    "features": [
      "Users have the ability to submit up to 1000 characters of feedback with the label of 'feature', 'bug', or 'other'"
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.16.2",
    "date": "March 3rd, 2024",
    "summary": "Fixed issue where pausing and resuming a game would create a new game instance, slowly increasing the site size until page is refreshed or app is closed.",
    "bug fixes": [
      "Fixed issue where pausing and resuming a game would create a new game instance, slowly increasing the site size until page is refreshed or app is closed."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.16.1",
    "date": "February 4th, 2024",
    "summary": "Added placeholder contact page.",
    "features": ["A placeholder 'Contact Us' page is added."],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.16.0",
    "date": "December 3rd, 2023",
    "summary": "Rebuilt the Sudoku board logic from the ground up. Removed hint logic, Drills, and Demo board.",
    "features": [
      "Move history is now preserved through browser refreshes, and is stored on the user's device.",
      "0 key can now be used to erase values or notes in a Sudoku cell",
      "Users can now unselect the currently selected cell.",
      "The end game modal is replaced with an end game screen.",
      "Improved performance of the Sudoku board",
      "Demo board and Drills are no longer functional and will be added back in a later release.",
      "Hints are no longer functional and will be added back in a later release."
    ],
    "bug fixes": [
      "Erase button is now disabled if a cell is not selected. User can no longer erase correct cells.",
      "Erase button is disabled if cell is empty, a given value, or is correct.",
      "Number pad buttons are disabled if selected cell is correct or if no cells are selected.",
      "Incorrect cells are highlighted red even if no cells are selected.",
      "Fixed a bug where timer would stop anytime the user would perform an action. A user spam clicking any action 'such as toggle notes button' would previously result in the pausing of the timer."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.15.1",
    "date": "November 25th, 2023",
    "summary": "Improved display for cards on small screens / window sizes.",
    "bug fixes": [
      "Improved display for cards on small screens / window sizes."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.15.0",
    "date": "November 4th, 2023",
    "summary": "Users now receive a drill explanation when they enter a drill.",
    "features": [
      "Users now recieve a drill explanation when they enter a drill.",
      "Users have the option to check a box if they do not want to see the explanation in the future."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.14.0",
    "date": "October 28th, 2023",
    "summary": "Restructured lessons to only take up a single page.",
    "features": [
      "Lessons now only use a single page, with support for scrolling."
    ],
    "targets": ["web", "mobile", "desktop"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.13.0",
    "date": "October 22nd, 2023",
    "summary": "Implemented desktop app support",
    "features": ["Sudokuru can now be downloaded and played on desktop."],
    "targets": ["desktop"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.12.0",
    "date": "October 21st, 2023",
    "summary": "Enhancements to lesson card page.",
    "features": [
      "Lesson cards have indicators based on when they are completed.",
      "User is presented with a popup warning if they want to learn a locked lesson. They can choose to ignore or heed this warning.",
      "The styling for the learning cards has been updated."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.11.0",
    "date": "October 15th, 2023",
    "summary": "Lesson buttons are replaced with lesson cards.",
    "features": [
      "Lesson buttons are replaced with lesson cards.",
      "Lesson cards display the difficulty of the lesson. (very easy, easy, intermediate, hard, very hard)",
      "Lesson cards have indicators based on when they are locked."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.10.0",
    "date": "October 8th, 2023",
    "summary": "Drill buttons are replaced with drill cards.",
    "features": [
      "Drill buttons are replaced with drill cards.",
      "Drill cards restructure based on the size of the screen."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "1.9.0",
    "date": "September 7th, 2023",
    "summary": "Fixed bugs with sudoku games and home page.",
    "features": [
      "Home page is restructured so that navigation buttons are below the demo board.",
      "Resizing of the home page content based on screen size is improved.",
      "Navigation buttons increase in size when being hovered over by mouse."
    ],
    "bug fixes": [
      "Resolved issue with scroll bar temporarily appearing on home page with first page render.",
      "Removed elevation effect from home navigation buttons as that resulted in weird rendering on mobile devices.",
      "Fixed issue where time spent playing and score showed as NaN in game results popup."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.8.2",
    "date": "August 31st, 2023",
    "summary": "Fixed bug with timer not starting on initial puzzle start.",
    "bug fixes": ["Fixed bug with timer not starting on initial puzzle start."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.8.1",
    "date": "August 31st, 2023",
    "summary": "Fixed bug with inputting values into Sudoku board",
    "bug fixes": [
      "Fixed an issue where the demo board was sharing state with the play board, causing inputs to the play board to be disabled when the demo board was in 'hint' mode."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.8.0",
    "date": "August 27th, 2023",
    "summary": "Restructured drawer menu",
    "features": [
      "Navigation sidebar is now closed by default, and can be opened through the hamburger menu icon.",
      "Navigation sidebar now has a close button for closing the sidebar.",
      "Profile and Statistics buttons have been changed from buttons to icon buttons.",
      "Theme colors have been adjusted slightly."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.7.0",
    "date": "August 26th, 2023",
    "summary": "Restructured website.",
    "features": [
      "The landing page and the home page have been combined.",
      "Learn, Drill, Home, and Play are now located on separate pages.",
      "Added a navigation bar on the left side of the page for navigating to these pages.",
      "Home page now has buttons for navigating directly to Drill, Learn, and Play pages.",
      "The drill navigation panel is replaced with buttons on the Drill page.",
      "Removed the difficulty slider.",
      "Sudoku games will now ignore the user's learned strategies when selecting puzzles to play."
    ],
    "bug fixes": [
      "The page header always displays the profile and settings buttons."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.6.0",
    "date": "August 20th, 2023",
    "summary": "Profile and statistics page no longer require Internet connection.",
    "features": [
      "Profile page no longer requires an Internet connection. User's profile settings are stored on their device.",
      "Statistics page no longer requires an Internet connection. User's profile settings are stored on their device."
    ],
    "bug fixes": [
      "The 'highlight peers' profile setting is renamed to 'highlight identical values' to be more accurate."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.5.0",
    "date": "August 19th, 2023",
    "summary": "Sudoku games no longer rely on user needing Internet access.",
    "features": [
      "Starting a Sudoku game now retrieves a puzzle from the user's device instead of requiring Internet access.",
      "Games are saved locally on the user's device instead of requiring an Internet connection to save games.",
      "Resuming games no longer requires an Internet connection, as the games are stored on the user's device."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.4.0",
    "date": "August 19th, 2023",
    "summary": "User's lesson progress is stored locally on their device.",
    "features": ["User's lesson progress is stored locally on their device."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.3.0",
    "date": "August 19th, 2023",
    "summary": "Login / Logout functionality is removed.",
    "features": ["The user no longer needs to login to play Sudoku."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.2.0",
    "date": "August 19th, 2023",
    "summary": "Removed dependency on online servers for drills and lessons.",
    "features": [
      "Drills are now stored locally on device, and no longer require an Internet connection to play.",
      "Lessons are now stored locally on device, and no longer require an Internet connection to access."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.1.0",
    "date": "June 13th, 2023",
    "summary": "Assorted enhancements to drills, sudoku board rendering, and demo board.",
    "features": [
      "Loading icon now appears while waiting for a Sudoku puzzle to be loaded in.",
      "Drill hint button no longer gives a hint, but instead resets the drill board if incorrect or navigates the user to the home page if correct.",
      "The demo board now cycles to a new puzzle once finished with a puzzle and continues auto-playing."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.0.1",
    "date": "June 3rd, 2023",
    "summary": "Fixed assorted issues with the login / logout process.",
    "bug fixes": [
      "Fixed issue with iOS login not working.",
      "Fixed an issue on iOS and Android where logging out did not close the logout window."
    ],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "1.0.0",
    "date": "April 17th, 2023",
    "summary": "Adjusted difficulty and strategy algorithm for retrieving puzzles",
    "bug fixes": [
      "Adjusted difficulty and strategy algorithm for retrieving puzzles"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "0.34.9",
    "date": "April 17th, 2023",
    "summary": "Added back selected font for Sudoku board.",
    "bug fixes": ["Added back selected font for Sudoku board."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.8",
    "date": "April 17th, 2023",
    "summary": "Restored amend note and simplify note hint functionality.",
    "bug fixes": ["Restored amend note and simplify note hint functionality."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.7",
    "date": "April 16th, 2023",
    "summary": "Fixed issue with a user's retrieved game not based on the user's learned games.",
    "bug fixes": [
      "When a user requests a new game, their learned lessons are now taken into account."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.6",
    "date": "April 15th, 2023",
    "summary": "Fixed issues with profile page.",
    "bug fixes": [
      "Fixed issue with profile page occasionally crashing.",
      "Fixed issue where user's profile settings are stored in memory even if they log out of the site."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.5",
    "date": "April 14th, 2023",
    "summary": "Fixed issue with hint text not being the correct color.",
    "bug fixes": ["Fixed issue with hint text not being the correct color."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.4",
    "date": "April 14th, 2023",
    "summary": "Fixed issue with pointing set not rendering title correctly on lesson.",
    "bug fixes": [
      "Fixed issue with pointing set not rendering title correctly on lesson."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "0.34.3",
    "date": "April 14th, 2023",
    "summary": "Fixed issue with drill drawer navigation being partially inaccessible on mobile.",
    "bug fixes": [
      "Fixed issue with drill drawer navigation being partially inaccessible on mobile."
    ],
    "targets": ["mobile"],
    "contributors": ["Mink234"]
  },
  {
    "version": "0.34.2",
    "date": "April 14th, 2023",
    "summary": "Implemented fix for cell being outlined when selected.",
    "bug fixes": ["Implemented fix for cell being outlined when selected."],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.34.1",
    "date": "April 14th, 2023",
    "summary": "Added tab name, tab icon, and app icon.",
    "features": [
      "Added tab name to website 'Sudokuru'.",
      "Added tab icon to the website.",
      "Added icon for the mobile app."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.34.0",
    "date": "April 14th, 2023",
    "summary": "Greatly improved light mode theme for site.",
    "features": [
      "Light mode now renders a different color logo.",
      "Light mode colors are more appealing.",
      "Much of the content is modified to use theme colors instead of hardcoded colors."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.33.10",
    "date": "April 14th, 2023",
    "summary": "Lesson panel buttons now restructure into rows based on screen size.",
    "bug fixes": [
      "Lesson panel buttons now restructure into rows based on screen size."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Thomas-Gallant"]
  },
  {
    "version": "0.33.9",
    "date": "April 14th, 2023",
    "summary": "Fixed bug with pointing set.",
    "bug fixes": ["Fixed bug with pointing set."],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "0.33.8",
    "date": "April 14th, 2023",
    "summary": "Fixed bug with highlighting for pointing pair hints.",
    "bug fixes": ["Fixed bug with highlighting for pointing pair hints."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.33.7",
    "date": "April 13th, 2023",
    "summary": "Improved dynamic sizing of landing page based on screen size.",
    "bug fixes": [
      "Improved dynamic sizing of landing page based on screen size."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.33.6",
    "date": "April 13th, 2023",
    "summary": "Fixed bug with topbar color on landing page with mobile.",
    "bug fixes": [
      "Topbar on landing page for mobile should no longer render as white."
    ],
    "targets": ["mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.33.5",
    "date": "April 13th, 2023",
    "summary": "Enhancements with lesson page.",
    "features": [
      "Loading text is replaced with loading indicator symbol for the lesson panel."
    ],
    "bug fixes": ["Lesson buttons now support any size lesson name."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.33.4",
    "date": "April 14th, 2023",
    "summary": "Enhanced time to support days, hours, minutes and seconds.",
    "features": [
      "Timer and statistics time reporting now supports hours and days."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.33.3",
    "date": "April 14th, 2023",
    "summary": "Disabled ability for user to learn a lesson more than once.",
    "bug fixes": [
      "Profile page only shows user learning a lesson once even if the lesson is completed multiple times."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.33.2",
    "date": "April 13th, 2023",
    "summary": "User is now automatically redirected to lessons if they have not completed the first 4 lessons.",
    "features": [
      "User is now automatically redirected to lessons if they have not completed the first 4 lessons."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "0.33.1",
    "date": "April 13th, 2023",
    "summary": "Added warning for user to confirm deleting statistics with the 'delete statistics' button",
    "features": [
      "Added warning for user to confirm deleting statistics with the 'delete statistics' button",
      "Made background for all alerts more transparent."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL"]
  },
  {
    "version": "0.33.0",
    "date": "April 12th, 2023",
    "summary": "Implemented pointing pair and pointing triplet hints.",
    "features": ["Implemented pointing pair and pointing triplet hints."],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "Gregory711"]
  },
  {
    "version": "0.32.0",
    "date": "April 12th, 2023",
    "summary": "Pressing the pause button now navigates the user to the home page.",
    "features": [
      "Pressing the pause button now navigates the user to the home page."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.31.2",
    "date": "April 12th, 2023",
    "summary": "Polished the header navigation buttons.",
    "features": [
      "Updated the size and spacing of the header navigation buttons."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL"]
  },
  {
    "version": "0.31.1",
    "date": "April 12th, 2023",
    "summary": "Fixed bug with notes and value rendering on mobile",
    "bug fixes": [
      "Rendering of values on mobile is now aligned.",
      "Note rendering on mobile no longer cuts off the numbers."
    ],
    "targets": ["mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.31.0",
    "date": "April 12th, 2023",
    "summary": "Enhanced the home page.",
    "features": [
      "The alert modals on the home page are updated to have more accurate help messages.",
      "The play and drill sections on the home page are displayed as 'locked' until the user has completed enough lessons to access them",
      "The 'do more lessons' alert modal is removed as it is no longer needed due to adding the conditional locks on play and drill sections."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.30.0",
    "date": "April 12th, 2023",
    "summary": "Redesign of the landing page for web and mobile.",
    "features": ["Redesign of the landing page for web and mobile."],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.29.0",
    "date": "April 11th, 2023",
    "summary": "Added landing page sudoku board which auto plays solving a puzzle.",
    "features": [
      "Added landing page sudoku board which auto plays solving a puzzle."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "salmoncore"]
  },
  {
    "version": "0.28.0",
    "date": "April 11th, 2023",
    "summary": "Added pointing set drills and updating logic for when user can play games and drills.",
    "features": [
      "Added pointing set drills.",
      "Updated logic for when user can play games and drills."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711"]
  },
  {
    "version": "0.27.1",
    "date": "April 11th, 2023",
    "summary": "Adjusted lesson page completion method.",
    "features": [
      "The 'complete lesson' button has been removed.",
      "The right check button at the end of the lesson now automatically completes the lesson for the user."
    ],
    "bug fixes": ["Fixed issue with desync with lesson rendering."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.27.0",
    "date": "April 11th, 2023",
    "summary": "Updated profile page and adding new settings.",
    "features": [
      "Added a profile setting for whether identical values should be highlighted on the board.",
      "Added a profile setting for whether the box of the selected cell should be highlighted on the board.",
      "Added a profile setting for whether the row of the selected cell should be highlighted on the board.",
      "Added a profile setting for whether the column of the selected cell should be highlighted on the board.",
      "Enhanced the visual display of the profile page."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.26.0",
    "date": "April 11th, 2023",
    "summary": "Updated profile page.",
    "features": [
      "Profile page formatting is updated.",
      "Profile page now displays user's name and email."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL"]
  },
  {
    "version": "0.25.0",
    "date": "April 11th, 2023",
    "summary": "Implemented total statistics tracking for sudoku games.",
    "features": [
      "Implemented total statistics tracking for sudoku games in statistics page.",
      "Added loading indicators for lessons, home, and statistics pages.",
      "Statistics page is scrollable now on web and mobile."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.24.1",
    "date": "April 11th, 2023",
    "summary": "Updated the sudoku end game screen.",
    "features": [
      "The sudoku end game screen now displays statistics in the same style and format as the statistics page.",
      "The user's learned lessons are now displayed in the profile page instead of the statistics page."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant", "salmoncore"]
  },
  {
    "version": "0.24.0",
    "date": "April 11th, 2023",
    "summary": "Replaced the lesson carousel with lesson button panel.",
    "features": [
      "Replaced the lesson carousel with lesson button panel.",
      "Lessons are now locked until the user completes the previous lesson."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.23.2",
    "date": "April 10th, 2023",
    "summary": "Removed the 'r' letter that was rendering in the home page.",
    "bug fixes": [
      "Removed the 'r' letter that was rendering in the home page."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.23.1",
    "date": "April 10th, 2023",
    "summary": "Improved readability of learned lessons in statistics page.",
    "bug fixes": [
      "Learned lessons in statistics page no longer have underscores in the name when displayed to the user."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.23.0",
    "date": "April 10th, 2023",
    "summary": "Added lesson tracking.",
    "features": [
      "User's learned lessons show up in Statistics page.",
      "New button in statistics page for users to reset their statistics.",
      "Lessons now have a button to press for the user to declare they have completed the lesson.",
      "Drill and Play modes now throw an alert if required lessons have not been completed.",
      "Drill buttons in drill drawer only are visible if the user has completed the associated lesson.",
      "Missing lessons are added to the lesson carousel."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.22.1",
    "date": "April 10th, 2023",
    "summary": "Fixed issue with loading in lessons.",
    "features": [
      "Lesson pages now have a loading screen when loading in lessons remotely."
    ],
    "bug fixes": ["Fixed error when loading in lessons."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.22.0",
    "date": "April 9th, 2023",
    "summary": "Once a game is finished, an alert box shows the user their statistics for that game.",
    "features": [
      "Once a game is finished, an alert box shows the user their statistics for that game."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.21.5",
    "date": "April 9th, 2023",
    "summary": "Added hint name and hint description when the user asks for a hint.",
    "features": [
      "Added hint name and hint description when the user asks for a hint.",
      "Hint arrow navigation is moved from the sides of the board to below the Sudoku board."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.21.4",
    "date": "April 8th, 2023",
    "summary": "Fixed issues with drill mode.",
    "bug fixes": [
      "Drill mode get hint functionality works again.",
      "Drill mode now displays visually if a value is incorrect like in play mode."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.21.3",
    "date": "April 8th, 2023",
    "summary": "Fixed issue where keyboard could no longer be used to input notes.",
    "bug fixes": [
      "Fixed issue where keyboard could no longer be used to input notes."
    ],
    "targets": ["web"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.21.2",
    "date": "April 3rd, 2023",
    "summary": "Fixed issue with drill games",
    "bug fixes": ["Fixed issue with drill games"],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.21.1",
    "date": "April 3rd, 2023",
    "summary": "Changes to Lesson pages.",
    "features": [
      "On mobile, navigation buttons for lessons are now at the bottom of the screen.",
      "The right arrow changes to a checkmark at the end of a lesson, which navigates the user to the home page.",
      "The landing page will automatically take the user to the Amend Notes lesson"
    ],
    "bug fixes": ["Improved sizing of lesson page content."],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234"]
  },
  {
    "version": "0.21.0",
    "date": "April 2nd, 2023",
    "summary": "Implemented light mode theme that can be toggled on in settings.",
    "features": [
      "Implemented light mode theme that can be toggled on in settings."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.20.4",
    "date": "March 20th, 2023",
    "summary": "Improved content sizing.",
    "features": [
      "Sudoku board action button sizes are now larger and therefore easier to use.",
      "Lesson right navigation button is removed at the end of the lesson.",
      "Lesson left navigation button is removed at the beginning of the lesson."
    ],
    "bug fixes": ["Lesson text is now larger on mobile"],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.20.3",
    "date": "March 30th, 2023",
    "summary": "Improved functionality of amend notes hint.",
    "features": ["Board amend notes now amends incorrect notes."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.20.2",
    "date": "March 29th, 2023",
    "summary": "User is no longer able to enter hint mode if there is an incorrect cell on the board.",
    "bug fixes": [
      "User is no longer able to enter hint mode if there is an incorrect cell on the board."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.20.1",
    "date": "March 29th, 2023",
    "summary": "Fixed a bug which caused drills to stop working.",
    "bug fixes": ["Fixed a bug which caused drills to stop working."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.20.0",
    "date": "March 29th, 2023",
    "summary": "Statistics are now displayed on Statistics page after the user completes a game.",
    "features": [
      "Statistics are now displayed on Statistics page after the user completes a game."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "Thomas-Gallant"]
  },
  {
    "version": "0.19.4",
    "date": "March 29th, 2023",
    "summary": "Improved Sudoku lessons.",
    "features": [
      "Updated the lesson carousel options to match the lessons we have created.",
      "Created a help popup for the lessons explaining the navigation."
    ],
    "bug fixes": [
      "Improved the content sizing for web and mobile based on screen size"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant", "Gregory711"]
  },
  {
    "version": "0.19.3",
    "date": "March 29th, 2023",
    "summary": "User cannot interact with the Sudoku board while in hint mode.",
    "bug fixes": [
      "User cannot interact with the Sudoku board while in hint mode.",
      "Erase, notes, and undo buttons are not toggleable.",
      "Any existing highlighting is cleared and user cannot select cells on the board."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.19.2",
    "date": "March 28th, 2023",
    "summary": "Drills no longer save state of previous drill sessions.",
    "bug fixes": ["Drills no longer save state of previous drill sessions."],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234"]
  },
  {
    "version": "0.19.1",
    "date": "March 28th, 2023",
    "summary": "Assorted bug fixes.",
    "bug fixes": [
      "Fixed rendering update issues with login / logout buttons and resume game button.",
      "Fixed issue where identical value highlights that also were invalid cells were rendering as identical values and not invalid values (green highlight instead of red highlight)"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.19.0",
    "date": "March 28th, 2023",
    "summary": "User's selected difficulty is now passed into play game.",
    "features": [
      "The user's selected difficulty is now taken into account when playing a game."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.18.0",
    "date": "March 28th, 2023",
    "summary": "Added drill submit button to verify if user has completed drill correctly.",
    "features": [
      "Added drill submit button to verify if user has completed drill correctly."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.17.5",
    "date": "March 28th, 2023",
    "summary": "The puzzle now displays to the user when they have an incorrect value in a cell.",
    "bug fixes": [
      "The puzzle now displays to the user when they have an incorrect value in a cell.",
      "Previously, it was only displayed to the user if there were two equal values on the same row / column / box."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.17.4",
    "date": "March 28th, 2023",
    "summary": "Resumed games now start the timer from the saved time value instead of 0",
    "bug fixes": [
      "Resumed games now start the timer from the saved time value instead of 0"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.17.3",
    "date": "March 28th, 2023",
    "summary": "Additional information is now saved with active games.",
    "features": [
      "The puzzle current time used is now stored with the active game.",
      "The number of hints used is now stored with the active game.",
      "The number of wrong cells played is now stored with the active game."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.17.2",
    "date": "March 27th, 2023",
    "summary": "Difficulty slider now shows user the numerical difficulty.",
    "features": [
      "Difficulty slider now shows user the numerical difficulty.",
      "The statistics page now has placeholder charts."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL"]
  },
  {
    "version": "0.17.1",
    "date": "March 27th, 2023",
    "summary": "Bug fixes with the lessons pages.",
    "bug fixes": [
      "Fixed the left / right arrows for lessons so they do not go out of bounds.",
      "Lesson content fits better on mobile devices."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234", "Thomas-Gallant"]
  },
  {
    "version": "0.17.0",
    "date": "March 27th, 2023",
    "summary": "Hint functionality implemented for hidden set strategies.",
    "features": ["Hint functionality implemented for hidden set strategies."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.16.4",
    "date": "March 26th, 2023",
    "summary": "Fixed bug with hint highlighting.",
    "bug fixes": ["Fixed bug with hint highlighting."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.16.3",
    "date": "March 26th, 2023",
    "summary": "Game no longer saves all user's moves and only latest move. This fixes issue where game data was too large to be processed.",
    "bug fixes": [
      "Game no longer saves all user's moves and only latest move. This fixes issue where game data was too large to be processed."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.16.2",
    "date": "March 26th, 2023",
    "summary": "Removed drills and lessons for strategies that are no longer planned to be implemented.",
    "bug fixes": [
      "Removed drills and lessons for strategies that are no longer planned to be implemented."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.16.1",
    "date": "March 26th, 2023",
    "summary": "Fixed bug with sudoku game that prevented navigation to home page after game completion.",
    "bug fixes": [
      "Fixed bug with sudoku game that prevented navigation to home page after game completion."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.16.0",
    "date": "March 26th, 2023",
    "summary": "Hint functionality implemented for obvious set strategies.",
    "features": ["Hint functionality implemented for obvious set strategies."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.15.0",
    "date": "March 26th, 2023",
    "summary": "Hint functionality implemented for simplify notes strategy.",
    "features": ["Hint functionality implemented for simplify notes strategy."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.14.0",
    "date": "March 26th, 2023",
    "summary": "Hint functionality implemented for amend notes strategy.",
    "features": ["Hint functionality implemented for amend notes strategy."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.13.4",
    "date": "March 25th, 2023",
    "summary": "Fixed bugs related to hint functionality for drill and play modes.",
    "bug fixes": [
      "Fixed bugs related to hint functionality for drill and play modes."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.13.3",
    "date": "March 25th, 2023",
    "summary": "Removed back button from drill sidebar and any site errors results in navigation to Home page.",
    "features": [
      "Removed back button from drill sidebar. (The Sudokuru logo acts as a home button and therefore the back button is unnecessary.)"
    ],
    "bug fixes": [
      "When game ends or there is a failure in the site, the user is navigated to the Home page instead of rendering a white screen."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.13.2",
    "date": "March 25th, 2023",
    "summary": "Fixed drill mode on mobile.",
    "bug fixes": ["Fixed drill mode on mobile."],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.13.1",
    "date": "March 25th, 2023",
    "summary": "Fixed start game and resume game on mobile.",
    "bug fixes": ["Fixed start game and resume game on mobile."],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.13.0",
    "date": "March 25th, 2023",
    "summary": "Hint functionality implemented for obvious single strategy.",
    "features": ["Hint functionality implemented for obvious single strategy."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.12.2",
    "date": "March 25th, 2023",
    "summary": "Fixed issue with resume game button render location.",
    "bug fixes": ["Fixed issue with resume game button render location."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.12.1",
    "date": "March 25th, 2023",
    "summary": "Home page content resizes based on the screen size.",
    "bug fixes": ["Home page content resizes based on the screen size."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.12.0",
    "date": "March 24th, 2023",
    "summary": "Hint functionality implemented for hidden single strategy.",
    "features": ["Hint functionality implemented for hidden single strategy."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Gregory711"]
  },
  {
    "version": "0.11.0",
    "date": "March 24th, 2023",
    "summary": "Added end game functionality.",
    "features": [
      "When a user completes a game, they are sent back to the home screen and the game is completed."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.10.0",
    "date": "March 24th, 2023",
    "summary": "Lesson pages are now added.",
    "features": [
      "Lesson pages can now be accessed from the lesson carousel.",
      "Arrow buttons on lesson page can be used to navigate the lessons."
    ],
    "bug fixes": ["Fixed the back button on the Drill sidebar."],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234", "Gregory711"]
  },
  {
    "version": "0.9.3",
    "date": "March 23rd, 2023",
    "summary": "Fixed bug with previously inserted values not being updatable when resuming a game.",
    "bug fixes": [
      "Fixed bug with previously inserted values not being updatable when resuming a game."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.9.2",
    "date": "March 23rd, 2023",
    "summary": "Enhancements to the Home page.",
    "features": [
      "Added titles for Drills, Lessons, and Play areas on home page.",
      "Created help buttons with pop-ups explaining each of the home page options."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.9.1",
    "date": "March 22nd, 2023",
    "summary": "Fixed an issue with resume game button rendering on mobile.",
    "bug fixes": [
      "Fixed an issue with resume game button rendering on mobile."
    ],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.9.0",
    "date": "March 22nd, 2023",
    "summary": "Resume Game functionality is implemented.",
    "features": [
      "Resume game functionality is implemented. User sees the 'resume game' button if they have a game in progress on the home page.",
      "Enhanced the difficulty slider user interface."
    ],
    "bug fixes": [
      "Fixed an issue where save game functionality was saving games incorrectly.",
      "Fixed bug with Drill drawer routing."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL", "Thomas-Gallant"]
  },
  {
    "version": "0.8.1",
    "date": "March 22nd, 2023",
    "summary": "Fixed bug with Sudoku puzzle difficulty.",
    "bug fixes": ["Fixed bug with Sudoku puzzle difficulty."],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant", "Gregory711"]
  },
  {
    "version": "0.8.0",
    "date": "March 22nd, 2023",
    "summary": "Implemented save game functionality to save game state after every modification to the Sudoku board.",
    "features": [
      "Implemented save game functionality to save game state after every modification to the Sudoku board."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "Thomas-Gallant"]
  },
  {
    "version": "0.7.1",
    "date": "March 21st, 2023",
    "summary": "Sudokuru logo now navigates user to home page.",
    "features": ["Sudoku logo now navigates user to home page."],
    "bug fixes": [
      "The Home button now navigates to Home page instead of last drill drawer location."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.7.0",
    "date": "March 21st, 2023",
    "summary": "Start Game now pulls Sudoku puzzles from the remote backend.",
    "features": [
      "Start Game now pulls Sudoku puzzles from the remote backend."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "Gregory711", "Thomas-Gallant"]
  },
  {
    "version": "0.6.1",
    "date": "March 20th, 2023",
    "summary": "Enhanced Drill sidebar.",
    "features": [
      "Hidden set and Obvious set are new fields in Drill sidebar that have subfields of 'obvious single', 'obvious pair', etc for better organization."
    ],
    "bug fixes": [
      "Drills now better accessibile on web with a 'Drills' button.",
      "Drills sidebar now has same color as the background of the site."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234"]
  },
  {
    "version": "0.6.0",
    "date": "March 18th, 2023",
    "summary": "Drills page now returns a puzzle from the remote database / backend servers",
    "features": [
      "Drills page now returns a puzzle from the remote database / backend servers"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Gregory711", "danielcosentino", "Thomas-Gallant"]
  },
  {
    "version": "0.5.3",
    "date": "March 18th, 2023",
    "summary": "Enforced user login before the user can proceed from the landing page.",
    "features": [
      "If the user clicks on 'get started' button before being logged in, an alert pops up requesting user to login.",
      "If the user logs out of the site / app, they get booted out to the landing page, where they need to log in again to access the site."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.5.2",
    "date": "March 18th, 2023",
    "summary": "Fixed a regression with inverted scrolling for Lessons carousel on web.",
    "bug fixes": [
      "Fixed a regression with inverted scrolling for Lessons carousel on web."
    ],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.5.1",
    "date": "March 15th, 2023",
    "summary": "Fixed issue on mobile where login/logout was not working.",
    "bug fixes": ["Fixed issue on mobile where login/logout was not working."],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.5.0",
    "date": "March 14th, 2023",
    "summary": "Adds timer and pause button to Sudoku Board",
    "features": [
      "Adds a timer on the top left of the Sudoku board",
      "Adds a pause / resume button on the top right of the Sudoku board, which pauses and resumes the timer."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "Thomas-Gallant"]
  },
  {
    "version": "0.4.10",
    "date": "March 11th, 2023",
    "summary": "Added hotkey input for delete and backspace keys for the Sudoku Board.",
    "features": [
      "Hitting the 'delete' or 'backspace' keys on web now perform the 'erase' operation on a selected cell."
    ],
    "targets": ["web"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.4.9",
    "date": "March 11th, 2023",
    "summary": "Sudoku board number buttons have been enhanced.",
    "features": [
      "The Sudoku board number buttons have been formatted into better looking buttons.",
      "The number buttons also now dynamically resize based on the screen size."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.4.8",
    "date": "March 11th, 2023",
    "summary": "Sudoku board action icons ('undo', 'erase', etc) size adjustments and reformatting.",
    "bug fixes": [
      "Sudoku board action icons ('undo', 'erase', etc) now resize better based on the screen size.",
      "Sudoku board action icons are now white instead of black on the green background, making them more visible."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.4.7",
    "date": "March 8th, 2023",
    "summary": "Replaced Sudoku action words with action icons",
    "features": [
      "The Sudoku board action words (for example, 'undo', 'erase', togglenotes', etc) have been replaced with action icons."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant", "danielcosentino"]
  },
  {
    "version": "0.4.6",
    "date": "March 7th, 2023",
    "summary": "Added hotkey input for 1-9 keys.",
    "features": ["Added hotkey input for 1-9 keys."],
    "targets": ["web"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.4.5",
    "date": "March 7th, 2023",
    "summary": "Enhanced functionality of lesson carousel.",
    "features": [
      "Lesson carousel now has back and forward buttons for selecting lessons.",
      "The lesson icon text is clickable on web, whereas whole icon is clickable on mobile."
    ],
    "bug fixes": [
      "Fixed issue where lesson carousel was not centered on mobile."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.4.4",
    "date": "March 6th, 2023",
    "summary": "Improved formatting and sizing for Landing page.",
    "bug fixes": [
      "Improved formatting and sizing for Landing page",
      "Landing page now takes into account screen size when determining size of content."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.4.3",
    "date": "March 6th, 2023",
    "summary": "Improved mobile formatting and Sudoku board buttons are now functional on mobile.",
    "bug fixes": [
      "Improved mobile formatting so content fits on screen better on mobile devices.",
      "It is now possible to use the Sudoku board buttons on mobile."
    ],
    "targets": ["mobile"],
    "contributors": ["salmoncore"]
  },
  {
    "version": "0.4.2",
    "date": "March 6th, 2023",
    "summary": "Fixed bug with carousel with inverted swipe directions on web.",
    "bug fixes": [
      "Fixed bug with carousel with inverted swipe directions on web."
    ],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.4.1",
    "date": "March 6th, 2023",
    "summary": "Enhanced the erase button functionality for Sudoku board",
    "bug fixes": [
      "The erase button can no longer remove the correct value from a selected cell.",
      "The erase button now removes all notes from a selected cell"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.4.0",
    "date": "March 6th, 2023",
    "summary": "Created carousel for viewing / selecting lessons and side panel for playing Drills. Also created placeholder pages for the lessons and drills.",
    "features": [
      "Created a carousel for selecting lessons to view.",
      "Created a sidebar for selecting drills to play.",
      "Created a play button for playing a Sudoku game, and added a placeholder difficulty slider.",
      "Removed the old sidebar for navigation."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Mink234", "Thomas-Gallant"]
  },
  {
    "version": "0.3.1",
    "date": "March 3rd, 2023",
    "summary": "User can no longer remove a correct note from a cell.",
    "bug fixes": ["User can no longer remove a correct note from a cell."],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino"]
  },
  {
    "version": "0.3.0",
    "date": "March 1st, 2023",
    "summary": "Added a landing page for Sudokuru.",
    "features": [
      "The user now must log in before being able to access the rest of the site.",
      "Toggle theme between light/dark mode is now in prototype",
      "Landing page includes Sudokuru logo and welcome text"
    ],
    "targets": ["web", "mobile"],
    "contributors": ["DahliaL", "Thomas-Gallant"]
  },
  {
    "version": "0.2.1",
    "date": "March 1st, 2023",
    "summary": "The Sudoku board now resizes to fit the screen.",
    "features": ["The Sudoku board now resizes to fit the screen."],
    "bug fixes": [
      "The number buttons for the board are now horizontal instead of vertical."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["danielcosentino", "Thomas-Gallant"]
  },
  {
    "version": "0.2.0",
    "date": "February 25th, 2023",
    "summary": "Implemented initial Sudoku Board",
    "features": ["A Sudoku board is now useable on the Home page"],
    "targets": ["web", "mobile"],
    "contributors": ["salmoncore", "danielcosentino"]
  },
  {
    "version": "0.1.3",
    "date": "February 24th, 2023",
    "summary": "Login state is preserved across refreshes / browser restarts for 10 hours.",
    "features": [
      "Users can now stay logged in through their browser for 10 hours at a time before being asked to log in again."
    ],
    "targets": ["web", "mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.1.2",
    "date": "February 22nd, 2023",
    "summary": "Implemented logout functionality for mobile.",
    "features": ["Implemented logout functionality for mobile."],
    "targets": ["mobile"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.1.1",
    "date": "February 22nd, 2023",
    "summary": "Implemented logout functionality for web.",
    "features": ["Implemented logout functionality for web."],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.1.0",
    "date": "January 27th, 2023",
    "summary": "Set up initial layout and navigation for the site.",
    "features": [
      "Created side navigation bar with placeholder pages.",
      "Created header with buttons for statistics page, profile page, and login."
    ],
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  },
  {
    "version": "0.0.1",
    "date": "December 12th, 2022",
    "summary": "Set up initial login for the site.",
    "targets": ["web"],
    "contributors": ["Thomas-Gallant"]
  }
]
